export default __webpack_public_path__ + "static/media/898.ca89d31b.gif";